import * as React from "react";
import {
  AppInsightsContext,
  AppInsightsErrorBoundary,
} from "@microsoft/applicationinsights-react-js";
import { appInsightsPlugin } from "utils/ApplicationInsights";
import UncaughtErrorsContainer from "containers/shared/UncaughtErrorsContainer";

const AppInsightsWrapper: React.FC = ({ children }) => {
  return (
    <AppInsightsErrorBoundary
      appInsights={appInsightsPlugin}
      onError={UncaughtErrorsContainer}
    >
      <AppInsightsContext.Provider value={appInsightsPlugin}>
        {children}
      </AppInsightsContext.Provider>
    </AppInsightsErrorBoundary>
  );
};

export default AppInsightsWrapper;
